module.exports = __webpack_public_path__ + "static/img/chejia_1.ade372b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Homepage/chejia_1.png
// module id = cGP5
// module chunks = 19